var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFBF1"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0EA5E9",
    d: "M18 20c0-8 6-14 14-14s14 6 14 14h-6c0-5-3-8-8-8s-8 3-8 8h-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#38BDF8",
    d: "M12 20h40v34H12z",
    rx: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    d: "M17 25h30v24H17z",
    rx: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F766E",
    strokeWidth: 2.5,
    d: "M22 25v24M29 25v24M36 25v24M43 25v24M17 32h30M17 41h30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M24 39c1-4 4-7 8-7s7 3 8 7c-2 3-5 5-8 5s-6-2-8-5Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 37,
    r: 1.4,
    fill: "#1F2937"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 37,
    r: 1.4,
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCage);
export default __webpack_public_path__ + "static/media/cage.18a267ba787cc3fef03dd1923b596a31.svg";
export { ForwardRef as ReactComponent };